export default __webpack_public_path__ + "static/media/1_How the wild cat got his eyes.e8f279a4.jpg";